import { Fragment, type JSX } from 'react';
import type { IMaintenanceCopySegment } from '@/types/Maintenance/Maintenance.types';

interface IProps {
  segments: IMaintenanceCopySegment[];
}

export default function MaintenanceCopy({ segments }: IProps): JSX.Element {
  return (
    <>
      {segments.map(({ text, emphasised, newLine }) => (
        <Fragment key={text}>
          {newLine && <br />}
          {emphasised ? <strong>{text}</strong> : text}
        </Fragment>
      ))}
    </>
  );
}
